import { render, staticRenderFns } from "./masterdata-modal.vue?vue&type=template&id=c0d1fdc8&"
import script from "./masterdata-modal.vue?vue&type=script&lang=js&"
export * from "./masterdata-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports